import styled from 'styled-components';
export { default } from './Header';

const drawerWidth = 300;
const headerHeight = 74;

export const styles = theme => ({
  appBar: {
    backgroundColor: theme.palette?.secondary.main || '#fff',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: `${headerHeight}px`,
    minHeight: `${headerHeight}px`,
    boxShadow: '0px 4px 8px rgba(51, 51, 51, 0.1)',
  },

  appBarShift: {
    marginLeft: `${drawerWidth}px`,
    heigth: `${headerHeight}px`,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  grid: {
    display: 'flex',
    justifyContent: 'end',
    flexDirection: 'row',
    alignItems: 'center',
    flexGrow: '1',
    width: '100%',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    boxShadow: 'none',
    flex: 1,
  },

  hide: {
    display: 'none',
  },
});

export const CallCenterLabel = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  font-family: 'Poppins Bold';
  font-size: 20px;
  padding-left: 24px;
`;

export const GroupLabel = styled.span`
  color: ${({ color }) => color || '#424242'};
  padding-left: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.02em;
`;

export const ImgLogo = styled.img`
  max-width: 164px;
  max-height: 40px;
  object-fit: contain;
`;

export const UpdateNotification = styled.div`
  display: flex;
  position: fixed;
  width: 100%;
  background-color: #ffd747;
  padding: 4px 16px;
  border: 1px solid #e6b800;
  text-align: center;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  z-index: 999999;
`;
